import { connect } from "react-redux";
import {
  DetailedLocationReviewV2 as Component,
  DetailedLocationReviewV2Props,
} from "./DetailedLocationReviewV2.component";
import { RootState } from "../../../../reducers";
import { getCurrentLocation, getDestination, getServiceDetails } from "../../../../selector";
import { getTowServiceDetails } from "../../helpers";
import { clearDestination, updateDestination, updateDestinationWithPredictionAddress } from "../../../../action";
import { getCustomDestination, getIsCustomAddress } from "../../selectors";
import { isEmpty } from "lodash";
import { clearCustomAddress } from "../../actions";

const mapStateToProps = (state: RootState) => {
  const serviceCostArray = getServiceDetails(state);
  const towServiceDetails = getTowServiceDetails(serviceCostArray);
  const isOpen = !!getDestination(state) || !isEmpty(getCustomDestination(state));

  return {
    currentLocation: getCurrentLocation(state),
    customLocation: getCustomDestination(state),
    isCustomAddress: getIsCustomAddress(state),
    isOpen,
    location: getDestination(state),
    towServiceDetails,
  } as Pick<
    DetailedLocationReviewV2Props,
    "currentLocation" | "customLocation" | "isCustomAddress" | "isOpen" | "location" | "towServiceDetails"
  >;
};

export const DetailedLocationReviewV2 = connect(mapStateToProps, {
  onClose: clearDestination,
  onCustomAddressClose: clearCustomAddress,
  onConfirmLocation: updateDestination,
  updateDestinationWithPredictionAddress,
} as Pick<DetailedLocationReviewV2Props, "onClose" | "onCustomAddressClose" | "onConfirmLocation" | "updateDestinationWithPredictionAddress">)(
  Component
);
